<ng-container appPopoverContainer>
    <div class="h-100 d-flex align-items-center">
        <button
            type="button"
            class="menubar-item h-100 d-flex py-0 align-items-center"
            appPopoverTrigger
        >
            <span
                *ngIf="showUsername"
                class="d-none d-sm-flex flex-column justify-content-center text-right me-2"
            >
                <span>{{ user$ | async }}</span>
                <ng-container
                    *ngIf="legalEntitySelection$ | async as legalEntitySelection"
                >
                    <span
                        class="small font-weight-regular text-secondary"
                        @fadeInOut
                        *ngIf="legalEntitySelection.show"
                    >
                        {{ legalEntitySelection.text }}
                    </span>
                </ng-container>
            </span>
            <tabler-icon class="sb-icon-md" name="user-circle"></tabler-icon>
        </button>
    </div>
    <div class="popover" appPopover>
        <ul role="listbox" class="dropdown-list">
            <li for="username">
                <span class="heading d-flex align-items-center pb-2">
                    <tabler-icon name="user-circle" class="sb-icon-md me-2"></tabler-icon>
                    <span>
                        {{ userEmail$ | async }}
                        <ng-container
                            *ngIf="impersonatedUser$ | async as impersonatedUser"
                        >
                            <div class="font-weight-regular">acting on behalf of</div>
                            {{ impersonatedUser.user_name }}
                        </ng-container>
                    </span>
                </span>
            </li>
            <li role="separator" for="username"></li>
            <ng-container *ngIf="legalEntities$ | async as legalEntities">
                <!-- Only display option for selecting active legal entities if user has access to more than one -->
                <ng-container *ngIf="legalEntities.length > 1">
                    <li role="listitem" for="legalEntities">
                        <span class="label" id="legalEntities_label">
                            Legal entities
                            <sb-tooltip-info
                                size="sm"
                                tooltipText="Select the legal entities you want to work with. Views and available accounts in forms will be filtered accordingly."
                            ></sb-tooltip-info>
                        </span>
                        <div class="overflow-y-auto" style="max-height: 250px">
                            <span
                                *ngFor="let legalEntity of legalEntities"
                                class="heading d-flex align-items-center pb-2"
                            >
                                <mat-checkbox
                                    [checked]="legalEntity.selected"
                                    (change)="toggleLegalEntity(legalEntity)"
                                >
                                    <span class="d-flex align-items-center">
                                        <span>
                                            {{ legalEntity.displayName }}
                                        </span>
                                    </span>
                                </mat-checkbox>
                            </span>
                        </div>
                    </li>
                    <li role="separator" for="legalEntities"></li>
                    <li
                        role="listitem"
                        for="legalEntities"
                        *ngIf="legalEntitySelection$ | async as legalEntitySelection"
                    >
                        <span class="heading d-flex align-items-center pb-2">
                            <mat-checkbox
                                [indeterminate]="
                                    legalEntitySelection.text !== 'all' &&
                                    legalEntitySelection.length > 0
                                "
                                [checked]="legalEntitySelection.text === 'all'"
                                (change)="
                                    toggleAllLegalEntity(
                                        legalEntitySelection.text === 'all'
                                    )
                                "
                            >
                                <span class="d-flex align-items-center">
                                    <span>Toggle all</span>
                                </span>
                            </mat-checkbox>
                        </span>
                    </li>
                    <li role="separator" for="legalEntities"></li>
                </ng-container>
            </ng-container>
            <li role="listitem" for="settings">
                <button
                    type="button"
                    class="d-flex align-items-center py-2"
                    (click)="showSettings()"
                >
                    <tabler-icon name="settings" class="sb-icon-md me-2"></tabler-icon>
                    Settings
                </button>
            </li>
            <li role="separator" for="settings"></li>
            <li role="listitem" for="currency">
                <span class="label" id="profileBaseCurrency_label">Base currency</span>
                <ng-container appPopoverContainer>
                    <button
                        type="button"
                        aria-describedby="profileBaseCurrency_label"
                        appPopoverTrigger
                        class="d-flex align-items-center py-2"
                    >
                        <tabler-icon name="coin" class="sb-icon-md me-2"></tabler-icon>
                        <ng-container *ngIf="baseCurrency$ | async as baseCurrency">
                            {{ baseCurrency }}
                        </ng-container>
                    </button>
                    <div
                        class="popover"
                        appPopover
                        [config]="{ placement: 'left-start', fallbackPlacements: [] }"
                    >
                        <ul role="listbox" class="dropdown-list">
                            <li
                                role="listitem"
                                *ngFor="let option of options$ | async | keyvalue"
                                [attr.aria-selected]="
                                    option.key === (baseCurrency$ | async)
                                "
                            >
                                <button
                                    type="button"
                                    style="flex-wrap: nowrap; white-space: nowrap"
                                    [appPopoverOption]="option"
                                    (click)="setBaseCurrency(option.key)"
                                >
                                    <ng-container *ngIf="codes.get(option.key) as ccy">
                                        <i
                                            class="flex-shrink-0 me-2 fp fp-square fp-round fp-{{
                                                ccy.countryCode.toLowerCase()
                                            }}"
                                        ></i>
                                    </ng-container>
                                    {{ option.key }}
                                    {{
                                        option.value.toLocaleString('sv-SE', {
                                            style: 'decimal',
                                            minimumFractionDigits: 5,
                                            maximumFractionDigits: 5
                                        })
                                    }}
                                </button>
                            </li>
                        </ul>
                    </div>
                </ng-container>
            </li>
            <li role="separator" for="currency"></li>
            <li role="listitem" for="logout">
                <button
                    type="button"
                    (click)="logout()"
                    class="d-flex align-items-center py-2"
                >
                    <tabler-icon
                        name="logout"
                        class="me-2"
                        style="height: 20px; width: 20px"
                    ></tabler-icon>
                    Log out
                </button>
            </li>
            <ng-container *ngIf="impersonatedUser$ | async as impersonatedUser">
                <li role="separator"></li>
                <li role="listitem">
                    <button
                        type="button"
                        (click)="endImpersonation()"
                        class="d-flex align-items-center py-2"
                    >
                        <tabler-icon
                            name="user-x"
                            class="me-2"
                            style="height: 20px; width: 20px"
                        ></tabler-icon>
                        <span class="text-left">
                            <span class="font-weight-regular pb-1 d-block">
                                Switch back to
                            </span>
                            <div>{{ user$ | async }}</div>
                        </span>
                    </button>
                </li>
            </ng-container>
        </ul>
    </div>
</ng-container>
